import { Col, Container, Row, Image } from "react-bootstrap";

const OrderConfirmation = () => {
  return (
    <Container style={{ padding: "50px" }}>
      <h2 style={{ textAlign: "center" }}>Order Confirmation</h2>

      <Row style={{ paddingTop: "40px" }}>
        <Col>
          <h4>Thank You for Your Purchase!</h4>
          <p>
            Thank you for choosing our company! We're
            delighted to have you as a customer.
          </p>
        </Col>
      </Row>
      <Row style={{ paddingTop: "40px" }}>
        <Col>
          <h4 style={{ textAlign: "center" }}>What's Next?</h4>
          <p>
            Your order has been successfully placed and is being processed. You
            will receive an email confirmation shortly with all the details of
            your purchase.
          </p>
        </Col>
      </Row>

      {/* <Row style={{ paddingTop: "40px" }}>
        <Col>
          <h4 style={{ textAlign: "center" }}>Your ID</h4>
          <p>
            You can now download your verified identity, with your new phone number by scanning the next QR code:
          </p>
          <div className="qr-code-placeholder">
                  <Image
                    src={require("./example-qr.png")}
                    alt="QR Code Placeholder"
                    style={{ width: "200px", height: "200px" }}
                  />
                </div>
        </Col>
      </Row> */}
    </Container>
  );
};

export default OrderConfirmation;
